/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-throw-literal */
/* eslint-disable no-async-promise-executor */
/* eslint-disable no-await-in-loop */
/* eslint-disable object-shorthand */
/* eslint-disable no-plusplus */
import { BLE as BleManager } from '@awesome-cordova-plugins/ble';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions';
import { isAndroidVersion, isIOSVersion } from 'utils/platform';

export class WaveIdManager {
    isScanning = false;

    logs = '';

    /**
    * 
    * @param {*} DEVICE_NAME 
    * @param {*} RF_IDEAS_SERVICE_ID_UUID
    * @param {*} WRITE_CHARACTERISTIC_UUID
    * @param {*} MANUFACTURER_DATA
    * @param {*} READ_CHARACTERISTIC_UUID
    */
    constructor(
        DEVICE_NAME,
        UUID_RF_IDEAS_SERVICE_ID,
        WRITE_CHARACTERISTIC_UUID,
        MANUFACTURER_DATA,
        READ_CHARACTERISTIC_UUID,
        setLogs
    ) {
        this.DEVICE_NAME = DEVICE_NAME;
        this.UUID_RF_IDEAS_SERVICE_ID = UUID_RF_IDEAS_SERVICE_ID;
        this.WRITE_CHARACTERISTIC_UUID = WRITE_CHARACTERISTIC_UUID;
        this.MANUFACTURER_DATA = isAndroidVersion ? MANUFACTURER_DATA.android : MANUFACTURER_DATA.ios;
        this.READ_CHARACTERISTIC_UUID = READ_CHARACTERISTIC_UUID;

        if (setLogs) {
            this.setLogs = setLogs;
            console.log('Set logs: ', setLogs);
        }
    }

    /**
      * sets up all the required event handlers. Make sure to invoke `destroy()` function once done.
      */
    async init() {
        BleManager.startStateNotifications().subscribe(state => {
            console.log(`Bluetooth is ${state}`);
        });
    }

    /**
     * Scan for matchin peripherals and returns the first one.
     * @param {*} time scaning time in seconds
     * @param {*} rssi rssi in dbi
     * @param {*} throwErrorIfAlreadyScanning if set to `true` will throw error if already scanning
     * @returns Promise returning the payload with matching peripheral, if found any.
     */
    startScan = async (time, rssi, throwErrorIfAlreadyScanning = false) => {
        this.addLogs("Start Scan\n", true);

        if (this.isScanning === true) {
            if (throwErrorIfAlreadyScanning === true) {
                throw 'SCANNING ALREADY IN PROGRESS';
            } else {
                await BleManager.stopScan();
                this.isScanning = false;
            }
        }

        this.isScanning = true;

        return new Promise(async (resolve) => {
            BleManager.startScan([this.UUID_RF_IDEAS_SERVICE_ID]).subscribe(async (device) => {
                const peripheral = device;

                if (peripheral.name) {
                    this.addLogs(`Device: ${JSON.stringify(peripheral)}`);
                }

                const flag = await this._getMatchedDevice(peripheral, rssi);

                if (flag === true) {
                    this.addLogs(`Matched Device: ${JSON.stringify(peripheral)}`);

                    BleManager.stopScan();
                    this.isScanning = false;

                    resolve({
                        peripheral,
                        flag: true,
                    });
                }
            });

            setTimeout(async () => {
                console.log("Compeleted Scan: ");

                await BleManager.stopScan();
                this.isScanning = false;

                resolve({
                    peripheral: null,
                    flag: false,
                });
            }, time * 1000);
        });
    };

    /**
      * Converts the `cardId` to the encoded `byte array`.
      * @param {*} cardId cardId to convert
      * @returns byte array
      */
    encodeCardId = cardId => {
        let tempCardId = cardId;
        if (cardId.length % 2 !== 0) {
            tempCardId = `0${cardId}`;
        }

        const cardIdData = new Uint8Array(tempCardId.length);

        for (let i = 0; i < tempCardId.length; ++i) {
            cardIdData[i] = 0;
        }

        // eslint-disable-next-line radix
        cardIdData[0] = parseInt(`0x${((tempCardId.length / 2) * 8).toString(16)}`);
        for (let i = 0, j = 1; i < tempCardId.length; i += 2, j++) {
            cardIdData[j] = parseInt(tempCardId[i] + tempCardId[i + 1], 16);
        }

        return cardIdData;
    };

    /**
     * Encodes and writes `cardId` to the provided peripheral device `WRITE_CHARACTERISTIC_UUID` and check
     * for aknowledgement from the peripheral by reading from `READ_CHARACTERISTIC_UUID`.
     * @param {*} peripheral pass connected peripheral
     * @param {*} cardId cardid to send
     * @returns authenticated device status
     */
    authPeripheral = async (peripheral, cardId) => {
        return new Promise(async (resolve) => {
            let encodedCardId = null;
            let validcodes = this.stringToBytes('Access valid');

            try {
                encodedCardId = this.encodeCardId(cardId);

                if (peripheral) {
                    if (peripheral.state === 'connected') {
                        await BleManager.disconnect(peripheral.id);
                    }

                    BleManager.connect(peripheral.id).subscribe(
                        async (peripheralData) => {
                            try {
                                this.addLogs(`encodedCard Id: ${JSON.stringify(encodedCardId)}`);

                                await BleManager.write(
                                    peripheralData.id,
                                    this.UUID_RF_IDEAS_SERVICE_ID,
                                    this.WRITE_CHARACTERISTIC_UUID,
                                    encodedCardId.buffer
                                );

                                try {
                                    const writeValue = 'success';

                                    this.addLogs(`Write Success`);

                                    const readData = await BleManager.read(
                                        peripheralData.id,
                                        this.UUID_RF_IDEAS_SERVICE_ID,
                                        this.READ_CHARACTERISTIC_UUID,
                                    );

                                    this.addLogs(`Read Success`);
                                    const readDataView = new DataView(readData);

                                    let success = true;

                                    for (let i = 0; i < validcodes.length; i++) {
                                        if (validcodes[i] !== readDataView.getUint8(i)) {
                                            success = false;
                                        }
                                    }

                                    this.addLogs(`Valid Code Check : ${success}`);

                                    validcodes = validcodes.join(', ');

                                    await BleManager.disconnect(peripheral.id);

                                    return resolve({
                                        success: success,
                                        readValue: this.bytesToString(readData),
                                        writeValue: writeValue,
                                        validcodes: validcodes,
                                        encodedData: Object.values(encodedCardId).join(', '),
                                    });
                                } catch (e) {
                                    this.addLogs(`Read Failed ${JSON.stringify(e)}`);

                                    validcodes = validcodes.join(', ');

                                    await BleManager.disconnect(peripheral.id);

                                    return resolve({
                                        success: false,
                                        readValue: e,
                                        writeValue: '',
                                        validcodes: validcodes,
                                        encodedData: Object.values(encodedCardId).join(', '),
                                    });
                                }
                            } catch (e) {
                                this.addLogs(`Write Failed ${JSON.stringify(e)}`);

                                validcodes = validcodes.join(', ');

                                await BleManager.disconnect(peripheral.id);

                                return resolve({
                                    success: false,
                                    readValue: '',
                                    writeValue: e,
                                    validcodes: validcodes,
                                    encodedData: Object.values(encodedCardId).join(', '),
                                });
                            }
                        },
                        () => {
                            this.addLogs(`Device disconnected`);

                            validcodes = validcodes.join(', ');
                            return resolve({
                                success: false,
                                readValue: '',
                                writeValue: '',
                                validcodes: validcodes,
                                encodedData: encodedCardId ? Object.values(encodedCardId).join(', ') : '',
                            });
                        }
                    );
                }
            } catch (e) {
                this.addLogs(`Card Id encoding failed.`);

                validcodes = validcodes.join(', ');
                return resolve({
                    success: false,
                    readValue: '',
                    writeValue: '',
                    validcodes: validcodes,
                    encodedData: encodedCardId ? Object.values(encodedCardId).join(', ') : '',
                });
            }
        });
    };

    /**
     * Checks and asks user for location permisions.
     * @returns `true` if permisssion granted
     */
    checkPermission = async () => {
        return new Promise(async (resolve, reject) => {
            if (isAndroidVersion) {
                const permission = await AndroidPermissions.checkPermission(
                    AndroidPermissions.PERMISSION.ACCESS_FINE_LOCATION,
                );

                if (permission) {
                    resolve(true);
                } else {
                    const reqResult = await AndroidPermissions.requestPermission(
                        AndroidPermissions.PERMISSION.ACCESS_FINE_LOCATION,
                    );
                    if (reqResult) {
                        resolve(true);
                    } else {
                        reject('LOCATION PERMISSION DENIED');
                    }
                }
            }
        });
    }

    /**
     *
     */
    enableBluetooth = async () => {
        try {
            await BleManager.enable();
        } catch (e) {
            throw 'BLUETOOTH NEEDS TO BE ENABLED';
        }
    }

    /**
     * Prompts user to enable location services, if in case disabled.
     * @param {*} `optinal` `message`
     * @returns `true` if service enabled
     */
    async enableLocation(message) {
        try {
            console.log("Location Service Dialog box", message || 'Please enable Location Services?');
            return true;
        } catch (e) {
            throw 'LOCATION NEEDS TO BE ENABLED';
        }
    }

    /**
     * clears all the event handlers, set up in the `init()` function
     */
    destroy = async () => {
        await BleManager.stopStateNotifications();
    }

    /**
     * for internal use
     * @param {*} peripheral Scaning peripheral device.
     * @param {*} rssi
     * @returns
     */
    _getMatchedDevice = async (peripheral, rssi) => {
        let matched = false;
        let matched2 = false;

        if (isAndroidVersion) {
            if (peripheral.connectable) {
                const pname = peripheral.name;

                if (pname === this.DEVICE_NAME && +peripheral.rssi >= +rssi && +peripheral.rssi <= 0) {
                    matched = true;

                    this.addLogs(`${pname} Device: MAU = ${this.bytesToString(peripheral.advertising)}`);

                    for (let i = 0; i < this.MANUFACTURER_DATA.length; i++) {
                        if (peripheral.advertising) {
                            const manufacturerData = peripheral.advertising;
                            const dataView = new DataView(manufacturerData);

                            if (this.MANUFACTURER_DATA[i] !== dataView.getUint8(i)) {
                                matched = false;
                                break;
                            }
                        } else {
                            matched = false;
                            break;
                        }
                    }

                    if (matched) {
                        matched2 = true;
                        this.isScanning = false;
                    }
                }
            }
        } else if (isIOSVersion) {
            if (peripheral.advertising.kCBAdvDataIsConnectable) {
                const pname = peripheral.name;

                if (pname === this.DEVICE_NAME && +peripheral.rssi >= +rssi && +peripheral.rssi <= 0) {
                    matched = true;

                    this.addLogs(`${pname} Device: MAU = ${this.bytesToString(peripheral.advertising.kCBAdvDataManufacturerData)}`);

                    for (let i = 0; i < this.MANUFACTURER_DATA.length; i++) {
                        if (peripheral.advertising.kCBAdvDataManufacturerData) {
                            const manufacturerData = peripheral.advertising.kCBAdvDataManufacturerData;
                            const dataView = new DataView(manufacturerData);

                            if (this.MANUFACTURER_DATA[i] !== dataView.getUint8(i)) {
                                matched = false;
                                break;
                            }
                        } else {
                            matched = false;
                            break;
                        }
                    }

                    if (matched) {
                        matched2 = true;
                        this.isScanning = false;
                    }
                }
            }
        }


        return matched2;
    };

    /**
     * for internal use
     */
    _handleStopScan = () => {
        console.log('Scanning stopped');
        this.isScanning = false;
    };

    /**
     * for internal use
     * @param {*} data
     */
    _handleDisconnectedPeripheral = data => {
        console.log('handleDisconnectedPeripheral', data);
    };

    /**
     * for internal use
     * @param {*} data
     */
    _handleUpdateValueForCharacteristic = data => {
        console.log(`Received data from ${data.peripheral} characteristic ${data.characteristic}`, data.value);
    };

    stringToBytes(string) {
        return string.split('').map((x) => { return x.charCodeAt(0) })
    }

    // ASCII only
    bytesToString(buffer) {
        return String.fromCharCode.apply(null, new Uint8Array(buffer));
    }


    addLogs = (log, isNew = false) => {
        if (isNew) {
            this.logs = `${log}\n`;
        } else {
            this.logs += `${log}\n`;
        }

        if (this.setLogs) {
            this.setLogs(this.logs);
        }
    }
};